import { paymentPolicy } from '@lib/seo'
import { NextSeo } from 'next-seo'

const PAYMENT_POLICY_PDF_PATH = '/pdfs/payment-policy-document.pdf'

const PayementPolicy = () => (
  <>
    <NextSeo {...paymentPolicy} />
    <object
      data={PAYMENT_POLICY_PDF_PATH}
      type="application/pdf"
      className="h-screen w-full bg-white"
    >
      <p className="text-grey">
        Looks like your browser does not support rendering this PDF. You can
        view our{' '}
        <a
          className="text-orange font-600 hover:underline"
          href={PAYMENT_POLICY_PDF_PATH}
        >
          payment policy here
        </a>{' '}
        instead.
      </p>
    </object>
  </>
)

export default PayementPolicy
